<template>
    <div class="text-center loading" v-if="loading">
        <b-spinner style="width: 10rem; height: 10rem;" type="grow" variant="info"/>
    </div>
    <div class="container h-100" v-else>
        <div class="row py-5">
            <b-col cols="4" offset="4" class="text-center">
                <h2>Course</h2>
            </b-col>
            <b-col cols="4">
                <div class="input-group">
                    <input type="text"
                           v-model="filter.course_title"
                           class="form-control"
                           placeholder="Search courses">
                    <div class="input-group-append">
                        <button class="btn btn-info"
                                type="button"
                                @click="getCourses"
                        >
                            <i class="fa fa-search"></i>
                        </button>
                    </div>
                </div>
            </b-col>
        </div>
        <div class="row">
            <div class="cols-12 col-md-6 col-lg-4 mb-5" v-for="course in courses" :key="course.id">
                <b-card
                        no-body
                        :img-src="course.course_thumbnail"
                        img-alt="Image"
                        img-top
                        img-width="350"
                        img-height="200"
                        tag="article"
                        class="h-100"
                >
                    <b-card-body>
                        <b-card-title>
                            <b-button variant="link"
                                      class="course-title text-left"
                                      @click="goToCourse(course)">
                                {{ course.course_title }}
                            </b-button>
                        </b-card-title>
                        <b-card-sub-title>
                            <icon name="eye"></icon>
                            {{ course.course_view }}
                        </b-card-sub-title>
                        <hr>
                        <div class="row">
                            <div class="col">
                                <p>
                                    <icon name="calendar-alt"></icon>
                                    {{ convertDateTime(course.created_at, "DD/MM/YYYY") }}
                                </p>
                                <p>
                                    <icon name="clock"></icon>
                                    {{ convertDateTime(course.created_at, "HH:mm:ss") }}
                                </p>
<!--                                <p>-->
<!--                                    <icon name="certificate"></icon>-->
<!--                                    Certificate-->
<!--                                </p>-->
                            </div>
<!--                            <div class="col m-auto text-center">-->
<!--                                <icon name="download"></icon>-->
<!--                                Document-->
<!--                            </div>-->
                        </div>
                    </b-card-body>
                </b-card>
            </div>
        </div>
        <div class="overflow-auto">
            <b-pagination size="md"
                          :total-rows="paginate.total"
                          :per-page="paginate.per_page"
                          v-model="filter.page"
                          >
            </b-pagination>
        </div>
    </div>
</template>

<script>
    import Service from "../../services/index";
    import moment from "moment";
    import BCard from "bootstrap-vue/src/components/card/card";
    import BCardBody from "bootstrap-vue/src/components/card/card-body";
    import BCardTitle from "bootstrap-vue/src/components/card/card-title";
    import BCardSubTitle from "bootstrap-vue/src/components/card/card-sub-title";
    import BCardText from "bootstrap-vue/src/components/card/card-text";
    import BButton from "bootstrap-vue/src/components/button/button";

    export default {
        name: "Index",
        components: {BButton, BCardText, BCardSubTitle, BCardTitle, BCardBody, BCard},
        data() {
            return {
                loading: true,
                courses: {},
                filter: {
                    page: 1,
                    course_title: "",
                    groupBy: ""
                },
                paginate: {}
            }
        },
        created() {
            this.getCourses();
        },
        methods: {

            getCourses() {
                Service.course.get(this.filter)
                    .then((res) => {
                        this.setData(res.result);
                        this.loading = false;
                    })
            },
            goToCourse(course){
                this.$router.push({
                    name: 'course',
                    params: {id: course.course_code},
                    props: { course_lecture: course.get_course_lectures }
                })
            },
            setData(data) {
                this.courses = data.data;
                this.paginate = data
            },
            convertDateTime(dateTime, output)
            {
                return moment(dateTime, "DD-MM-YYYY HH:mm:ss").format(output)
            }

        },
        watch: {
            'filter.page'() {
                this.loading = true;
                this.getCourses();
            }
        }
    }
</script>

<style scoped>
    a {
        color: #1c004a !important;
    }

    .course-title{
        color: #1c004a !important;
        padding: 0!important;
        font-size: 18px;
    }
</style>